import React from 'react';
import ReactDOM from 'react-dom';
import registerInterceptors from 'config/fetch';
import {
  initSessionBroadcast,
  initIdleHandler,
  initWebWorker,
  isLoggedIn
} from 'config/auth';
import 'react-select/dist/react-select.css';

import Root from 'Common/components/Root';
import 'Common/styles/base.css';

registerInterceptors();
initSessionBroadcast();
initIdleHandler(window.sessionTimeoutMs);
initWebWorker();

// Initialize API keys ready flag
window.apiKeysReady = false;

// Fetch API keys if user is logged in
if (isLoggedIn()) {
  console.log('App loaded and user is logged in, fetching API keys...');
  import('./config/fetchApiKeys').then(
    ({ default: fetchApiKeys, mergeApiKeysIntoConfig }) => {
      fetchApiKeys(window.currentRegion)
        .then(apiKeys => {
          mergeApiKeysIntoConfig(apiKeys);
          console.log('API keys fetched and merged in App.jsx');
          window.apiKeysReady = true;
        })
        .catch(error => {
          console.error('Failed to fetch API keys in App.jsx:', error);
          window.apiKeysReady = true; // Continue anyway
        });
    }
  );
} else {
  // Not logged in, mark as ready (keys will be fetched after login)
  window.apiKeysReady = true;
}

const node = document.getElementById('root');

const render = Component => {
  ReactDOM.render(<Component />, node);
};

render(Root);

// Store as env for debugging
const env = process.env;

if (env.HOT && module.hot) {
  module.hot.accept(Root, () => {
    render(Root, node);
  });
}
